import {register} from '@shopify/theme-sections';

import $, {type} from 'jquery';
import {util} from '../lib/util';
import {discounts} from '../lib/discounts';
import packageProtection from '../lib/packageProtection';

register('order-confirmation', {
  refreshCart(cart) {
    if (!cart || !cart.items[0]) { return; }
    const props = cart.items[0].properties;
    const onetime = props.onetime;
    const checkoutParam = util.getUrlParam('checkout');
    const shouldDisableDiscount = checkoutParam === 'shopify';
    const discountCode = shouldDisableDiscount ? null : discounts.getDiscountCode();

    const frag = document.createDocumentFragment();
    let price = 0;
    let discountedPrice = 0;
    let quantity = 0;

    cart.items.forEach((item) => {
      price += (item.price * item.quantity);
      quantity += item.quantity;
      const div = document.createElement('DIV');
      div.classList.add('meal');

      // Temporary hack to replace serving sizes with formatted CSS version
      const title = item.product_title.replace(' (4 Servings)', ' <span class="serving-size">(4 Servings)</span>');

      div.innerHTML = `
        <div class="image-wrapper">
            <div class="placeholder-image" style="background-image: url('${item.image}')"></div>
        </div>
        <div class="meal-order-name">
            <div class="meal-qty"><span class="meal-num">${item.quantity}</span></div>
            <h3>${title}</h3>
        </div>
      `;
      frag.appendChild(div);
    });

    discountedPrice = discounts.calculateDiscountedBoxPrice(discountCode, price / 100, onetime);

    this.$cartContainer.html(frag);

    this.refreshPlan();
    this.refreshFrequency(discountCode);
    this.refreshOrderSummary(discountCode, onetime);

    if (!this.selectedPlan) {
      discounts.refreshPrice({
        $price: this.$price,
        $priceShipping: this.$priceShipping,
        $discountedPrice: this.$discountedPrice,
        $discountDetail: this.$discountDetail,
      }, price, discountedPrice, discountCode, shouldDisableDiscount, onetime);
      discounts.refreshShipping(this.$priceShipping, price, discountCode, this.customShippingRate, this.priceShippingThreshold);
    }
  },

  refreshOrderSummary(discountCode, onetime) {

    const $pricing = $('.order-summary-wrapper .pricing');

    // Get shipping parameters
    const shippingAmount = window.basket.getDisplayShipping() || 1000;
    const freeShippingUrlParam = (String(util.getUrlParam('free_shipping', 'false')).toLowerCase() === 'true');
    const freeShipping = this.selectedPlan ? this.selectedPlan.freeShipping : freeShippingUrlParam;

    // Get plan discount
    const planDiscountAmount = this.selectedPlan ? this.selectedPlan.discountAmount : 0;
  
    const shippingHTML = `
      <div class="line-item shipping ${freeShipping ? 'free' : ''}">
        <span>Shipping</span><span><span class="amount">${this.formatCents(shippingAmount)}</span>${freeShipping ? '<span class="text-celebration">&nbsp;FREE</span>' : ''}</span>
      </div>
    `;
    const items = this.itemsWithPlanDiscountPrices();
    const packageProtectionEnabled = window.basket.getPackageProtection();
    let subtotal = items.reduce((sum, item) => sum + (item.planDiscountPrice * item.item.quantity), 0);
    subtotal += planDiscountAmount;

    const traditionalDiscountPrice = discounts.calculateDiscountCents(discountCode, items, onetime);
    let total = subtotal - planDiscountAmount - traditionalDiscountPrice;
    if (packageProtectionEnabled) { total += this.packageProtection.product.price; }
    if (!freeShipping) { total += shippingAmount; }

    $pricing.empty();
    $pricing.append(`
      <div class="subtotal line-item">
        <span>Subtotal</span>
        <span>${this.formatCents(subtotal)}</span>
      </div>
    `);
    if (this.packageProtection.enabled) {

      $pricing.append(`
        <div class="line-item package-protection">
          <span class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" id="packageProtectionSwitch" ${packageProtectionEnabled ? 'checked' : ''}>
            <label class="form-check-label" for="packageProtectionSwitch">
              <span class="${packageProtectionEnabled ? 'text-celebration' : ''}">
                ${this.packageProtection.product.title}
              </span>
              <a class="tooltip-inline" aria-label="${this.packageProtection.product.description}" data-microtip-position="top" data-microtip-size="medium" role="tooltip" tabindex="0">
                <i class="fa fa-circle-info"></i>
              </a>
            </label>
          </span>
          <span>${packageProtectionEnabled ? this.formatCents(this.packageProtection.product.price) : 'Disabled'}</span>
        </div>
      `);

      $('#packageProtectionSwitch').on('change', (e) => {
        window.basket.setPackageProtection(e.currentTarget.checked);
        this.refreshCart(window.basket);
      });
    }

    if (this.selectedPlan && planDiscountAmount > 0) {
      const msg = this.selectedPlan.customDiscountMsg || `${this.selectedPlan.itemQuantity} Items Box Discount`;
      $pricing.append(`
        <div class="box-discount line-item">
          <span>${msg}</span>
          <span class="text-celebration">${this.formatCents(this.selectedPlan.discountAmount * -1)}</span>
        </div>
      `);
    }
    if (traditionalDiscountPrice > 0) {
      $pricing.append(`
        <div class="traditional-discount line-item">
          <span>${discounts.discountText(discountCode)}</span>
          <span class="text-celebration">${this.formatCents(traditionalDiscountPrice * -1)}</span>
        </div>
      `);
    }
    $pricing.append(shippingHTML);
    $pricing.append('<hr />');
    $pricing.append(`<div class="total line-item"><span>Total</span><span>${this.formatCents(total)}</span>`);
  },

  itemsWithPlanDiscountPrices() {

    if (!this.selectedPlan) {
      return window.basket.items.map((item) => ({item, planDiscountPrice: item.price}));
    }

    const itemWithRemainder = [...window.basket.items].reverse().find((item) => item.quantity === 1);
    const discountWillBeEvenlyDistributed = ((this.selectedPlan.discountAmount > 0) && itemWithRemainder);

    if (discountWillBeEvenlyDistributed) {
      const discountPerItem = Math.floor(this.selectedPlan.discountAmount / this.selectedPlan.itemQuantity);
      const discountRemainder = this.selectedPlan.discountAmount - (discountPerItem * this.selectedPlan.itemQuantity);

      return window.basket.items.map((item) => {
        let price = item.price - discountPerItem;
        if (itemWithRemainder && item.id === itemWithRemainder.id) { price -= discountRemainder; }

        return {item, planDiscountPrice: price};
      });
    } else {
      const discountPerItem = Math.ceil(this.selectedPlan.discountAmount / this.selectedPlan.itemQuantity);
      return window.basket.items.map((item) => ({item, planDiscountPrice: item.price - discountPerItem}));
    }
  },

  formatCents(cents) {
    const prefix = cents < 0 ? '-' : '';
    return `${prefix}$${(Math.abs(cents) / 100).toFixed(2)}`;
  },

  refreshPlan() {
    if (window.basket.items.length >= 1) {
      this.$plan.html(window.basket.items[0].variant_title);
    }
  },

  refreshFrequency(discountCode) {
    if (!window.basket.items.length >= 1) { return; }
    const props = window.basket.items[0].properties;
    const onetime = props.onetime;
    const interval = props.shipping_interval_frequency;
    const unit = props.shipping_interval_unit_type;

    const checkoutParam = util.getUrlParam('checkout');
    const frequency_editable = util.getUrlParam('frequency_editable');
    const appliesTo = discountCode && discountCode.applies_to_product_type;

    let message;
    if (interval == 1) {
      message = `every ${unit.slice(0, -1)}`;
    } else {
      message = `every ${interval} ${unit}`;
    }

    if (checkoutParam === 'shopify') {
      this.$planLabel.text('Delivery Info');
      this.$deliveryLabel.text('Requested Delivery Date');
      this.$boxHeader.text('Box Contents');
      this.$disclaimer.hide();
      this.$subscriptionPlanText.hide();
      this.$onetimePlanText.show();
    } else if (onetime) {
      this.$planLabel.text('Delivery Info');
      this.$deliveryLabel.text('Requested Delivery Date');
      this.$boxHeader.text('Box Contents');
      this.$disclaimer.hide();
      if (appliesTo === 'ONETIME' || appliesTo === 'ALL') {
        discounts.hideBanner(false);
      } else {
        discounts.hideBanner(true);
      }
      if (frequency_editable === 'false') {
        this.$subscriptionPlanText.hide();
        this.$onetimePlanText.show();
      } else {
        this.$subscriptionPlanText.show();
        this.$onetimePlanText.hide();
      }
    } else {
      this.$planLabel.text('Your Plan');
      this.$deliveryLabel.text('Your First Delivery Date');
      this.$boxHeader.text('Your First Box');
      this.$disclaimer.show();
      if (appliesTo === 'SUBSCRIPTION' || appliesTo === 'ALL') {
        discounts.hideBanner(false);
      } else {
        discounts.hideBanner(true);
      }
      this.$subscriptionPlanText.show();
      this.$onetimePlanText.hide();
      this.$frequency.html(message);
    }
  },

  refreshDate() {
    const self = this;

    function updateDateText() {
      if (window.basket.available_delivery_dates && window.basket.available_delivery_dates[0]) {
        self.$deliveryDateError.hide(0);
        self.$deliveryDateSelector.show(0);
        self.$deliveryDateSelector.empty();
        window.basket.available_delivery_dates.forEach((date) => {
          const parsed_date = util.parseDate(date);
          self.$deliveryDateSelector.append(new Option(
              parsed_date.toLocaleDateString(
                  'default',
                  {weekday: 'long', month: 'long', day: 'numeric'},
                  ),
              util.dateToISOString(parsed_date),
));
        });
      } else {
        self.$deliveryDateSelector.hide(0);
        self.$deliveryDateError.show(0);
      }
    }

    if (window.basket.available_delivery_dates) {
      updateDateText();
    } else {
      // Assume zip code if not present.
      const zipcode = util.getUrlParam('zip_code', '11206');

      util.getAvailableDeliveryDates({
        zipcode,
        error(err) {
          if (err.status === 422) {
            window.location.assign('/pages/we-dont-ship-to-your-location');
          } else {
            // Let user proceed on any error.
            window.console.log('error', err);
            updateDateText();
          }
        },
        callback(res) {
          const delivery_dates = res.map((delivery_date) => { return delivery_date.delivery_date; });
          window.basket.setAvailableDeliveryDates(delivery_dates);
          updateDateText();
        },
      });
    }
  },

  fillOutDeliveryInstructions() {
    const $cartNote = this.$cartNote;
    const note = $cartNote.val();
    const charCount = note.length;
    const diff = $cartNote.attr('maxlength') - charCount;

    if (diff > 0) {
      $cartNote.val(new Array(diff + 1).join(' ') + note);
    }
  },

  onLoad() {
    this.$container = $(this.container);
    this.$cartContainer = $('#cart-confirmation');
    this.$plan = $('#plan-confirmation');
    this.$editLink = $('#edit-link');
    this.$frequency = $('#frequency-confirmation');
    this.$frequencySelect = $('#frequency-confirmation-select');
    this.$disclaimer = $('.subscription-plan-disclaimer');
    this.$price = $('#box-price-confirmation-original');
    this.$priceShipping = $('#price-shipping');
    this.$discountedPrice = $('#box-price-confirmation-discount');
    this.$discountDetail = $('[data-price-confirmation-discount-detail]');
    this.$discountDetail = $('[data-price-confirmation-discount-detail]');
    this.$deliveryDateSelector = $('#delivery-date-selector');
    this.$deliveryDateError = $('#delivery-date-error');
    this.$note = $('.cart-note');
    this.namespace = `.${this.id}`;
    this.$nextStepBtnOne = this.$container.find('#toCheckoutOne');
    this.$nextStepBtnTwo = this.$container.find('#toCheckoutTwo');
    this.$boxHeader = this.$container.find('.box-header label');
    this.$planLabel = this.$container.find('#your-plan-label');
    this.$deliveryLabel = this.$container.find('#delivery-date-label');
    this.$subscriptionPlanText = $('#subscription-plan-text');
    this.$onetimePlanText = $('#onetime-plan-text');
    this.$cartNote = $('#special-delivery-instructions');
    this.$detoxFaq = $('.detox-order-faq');
    this.$flowFooter = $('#subscription-flow-footer');
    this.customShippingRate = $('#custom-shipping-rate').val();
    this.priceShippingThreshold = $('[data-shipping-threshold]').data('shippingThreshold');
    this.packageProtection = packageProtection.init(window.basket);
    const self = this;
    let processing = false;

    document.addEventListener('basket:init', (evt) => {
      const {response} = evt.detail;
      self.refreshCart(response);
    });
    document.addEventListener('basket:updated', (evt) => {
      const {response} = evt.detail;
      self.refreshCart(response);
    });
    document.addEventListener('freq:selected', (evt) => {
      const {response} = evt.detail;
      self.refreshCart(response);
      window.basket.unsetOptimizeProperty('frequency');
    });
    document.addEventListener('flow:selected', (evt) => {
      const {response} = evt.detail;
    });
    document.addEventListener('step:order-confirmation', (evt) => {
      const props = window.basket.items[0].properties;
      let interval = props.shipping_interval_frequency;
      const onetime = props.onetime;

      const checkoutParam = util.getUrlParam('checkout');
      const frequency_editable = util.getUrlParam('frequency_editable');
      const box_editable = util.getUrlParam('box_editable');

      if (box_editable === 'false') {
        this.$editLink.hide();
      }

      if (frequency_editable === 'false' || checkoutParam === 'shopify') {
        this.$disclaimer.hide();
        this.$frequencySelect.hide();
        this.$frequency.show();
      } else {
        if (onetime) {
          interval = 0;
          if (this.$frequencySelect.find('option[value="0"]').length === 0) {
            this.$frequencySelect.prepend('<option value="0">just once</option>');
          }
        } else {
          this.$frequencySelect.find('option[value="0"]').remove();
        }
        this.$frequencySelect.val(interval).trigger('change', {pushGTM: false});
        this.$disclaimer.show();
        this.$frequencySelect.show();
        this.$frequency.hide();
      }
    });

    document.addEventListener('plan-v2:selected', (e) => {
      const {response} = e.detail;
      this.selectedPlan = response;
    });

    if (sessionStorage.getItem('mcsp')) {
      setTimeout(() => {
        const planFromSession = JSON.parse(sessionStorage.getItem('mcsp'));
        const planEvent = new CustomEvent('plan-v2:selected', {detail: {response: planFromSession, initial: true}});
        document.dispatchEvent(planEvent);
      }, 500);
    }

    // Handle frequency change
    this.$frequencySelect.on('change', async (e, param) => {
      const freq = Number(e.currentTarget.value);
      setTimeout(() => {

        if (param && param.pushGTM === false) {
          // Do not push GTM
        } else {

          /**
           * GTM - updateFrequency
           */
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'updateFrequency',
            frequencyProperties: {
              is_subscription: freq > 0,
              frequency: freq,
            },
          });
        }

        util.updateFrequency(e.currentTarget.value);
      }, 200);
    });

    this.$deliveryDateSelector.on('change', (e) => {

      /**
       * GTM - updateDeliveryDate
       */
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'updateDeliveryDate',
        deliveryDateProperties: {
          date: e.currentTarget.value,
        },
      });
    });

    const flow = window.mosaic.views.state.flow;

    if (
      !window.basket.items.length &&
      util.getUrlParam('step') === '4' &&
      (util.getUrlParam('prepopulated_meals') === undefined || util.getUrlParam('auto_add_meals') === undefined)
    ) {
      console.log('return to meals step');
      // return to meal page
      const mealStep = window.mosaic.views.flows[flow].indexOf(['meal-menu', 'meals']) + 1;

      window.mosaic.views.nextStep(flow, mealStep);
    }


    window.basket.unsetAvailableDeliveryDates();
    self.refreshDate();

    self.refreshCart(window.basket);

    $('.js-to-step').click((e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const flowState = window.mosaic.views.state.flow;
      const stepName = e.currentTarget.dataset.step;
      const step = window.mosaic.views.flows[flowState].map((view) => view[0]).indexOf(stepName) + 1;

      if (stepName === 'meal-menu') {

        /**
         * GTM - editProducts
         */
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'editProducts',
        });
      }

      window.mosaic.views.nextStep(flowState, step);
    });

    const completeCheckout = async (clickEvent) => {
      clickEvent.preventDefault();
      if (!processing) {

        try {
          processing = true;
          util.savingAnimation('#toCheckoutOne', 'Sending to our chefs...');
          util.savingAnimation('#toCheckoutTwo', 'Sending to our chefs...');
          this.$nextStepBtnOne.addClass('disabled').attr('disabled', true);
          this.$nextStepBtnTwo.addClass('disabled').attr('disabled', true);
          const props = (window.basket.items[0] || {}).properties || {};
          const checkoutParam = util.getUrlParam('checkout');
          const onetime = props.onetime;

          // Fill out cart note
          self.fillOutDeliveryInstructions();

          const cart_data = {
            note: this.$note.val(),
            attributes: {},
          };
          if (window.basket.available_delivery_dates) {
            cart_data.attributes = {
              requested_delivery_date: self.$deliveryDateSelector.val(),
            };
          }

          // Pulls in Optimize Data
          const additionalCartData = $('.cart-extras').map((index, element) => {
            const $element = $(element);
            const key = $element.attr('name');
            const value = $element.val();

            if (key && value && value !== 'value') {
              return {
                key,
                value,
              };
            }
          });

          for (let index = 0; index < additionalCartData.length; index++) {
            const data = additionalCartData[index];
            cart_data.attributes[data.key] = data.value;
          }

          // Pull in UTM params
          cart_data.attributes = {
            ...cart_data.attributes,
            user_segmentation: window.mosaic.views.state.user_segmentation,
            utm_source: 'direct',
            utm_medium: 'direct',
            utm_campaign: '',
            utm_content: '',
            ...basket.getUTM(),
          };

          // Clear Optimize Frequency
          window.basket.unsetOptimizeProperty('frequency');

          util.insertUrlParam('checkoutCreated', 'true');

          /**
           * GTM - initiateCheckout
           */
          const productsPayload = window.basket.items.map(({
            product_id,
            product_title,
            quantity,
          }) => JSON.stringify({product_id, product_title, quantity}));
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'initiateCheckout',
            cartProperties: {
              products: productsPayload,
            },
          });
          const cartAttributes = cart_data.attributes || {};
          const checkoutURL = await util.createShopifyCart(window.basket, cartAttributes, onetime);
          window.location.assign(checkoutURL);

          util.finishSaveAnimation('#toCheckoutOne', 'Processed', 'Continue to checkout');
          util.finishSaveAnimation('#toCheckoutTwo', 'Processed', 'Continue to checkout');
          this.$nextStepBtnOne.removeClass('disabled').attr('disabled', false);
          this.$nextStepBtnTwo.removeClass('disabled').attr('disabled', false);
          processing = false;
        } catch (error) {
          console.error(error);
          processing = false;
          util.finishSaveAnimation('#toCheckoutOne', 'Error');
          util.finishSaveAnimation('#toCheckoutTwo', 'Error');
        }
      }
    };

    this.$nextStepBtnOne.click(completeCheckout);
    this.$nextStepBtnTwo.click(completeCheckout);

    // Trim cart note input on load to remove extra space.
    const val = this.$cartNote.val();
    this.$cartNote.val(val.trim());

    let specLength = this.$cartNote.val().length;
    $('#characters-remaining-number').html(35 - specLength);

    // Update character count on special delivery instructions
    this.$cartNote.bind('input propertychange', () => {
      specLength = this.$cartNote.val().length;
      $('#characters-remaining-number').html(35 - specLength);
    });

    this.$cartNote.on('blur', () => {

      /**
       * GTM - updateDeliveryInstructions
       */
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'updateDeliveryInstructions',
      });
    });
  },
});
